// CLASSES
import AppConfig from "@classes/AppConfig";
import Validator from "@classes/Validator";

export default function(props, state)
{
    if (AppConfig.get("developmentOptions").ignoreFullfillment === true)
    {
        return true;
    }

    const {fields, validFields} = state;


    for (const name in validFields)
    {
        if (validFields[name] === false)
        {
            return false;
        }
    }

    /**
     * First and last name needs to be entered
     */
    if ((fields.is_company && fields.customer_firstname.length === 0) ||
        (!fields.is_company && (fields.customer_firstname.length === 0 || fields.customer_lastname.length === 0)))
    {
        return false;
    }

    /**
     * One of the checkboxes regarding information to be changed needs to be checked
     */
    if (!fields.checkbox_change_phone.checked &&
        !fields.checkbox_change_account.checked &&
        !fields.checkbox_change_email.checked)
    {
        return false;
    }

    if (fields.checkbox_change_phone.checked)
    {
        if (fields.customer_phone_old.length === 0 || fields.customer_phone_new.length === 0)
        {
            return false;
        }

        // Phone numbers are same
        if (fields.customer_phone_old === fields.customer_phone_new)
        {
            return false;
        }
    }

    if (fields.checkbox_change_account.checked)
    {
        if (fields.customer_autogiro_bank_clearingno_old.length === 0 ||
            fields.customer_autogiro_bank_clearingno.length === 0 ||
            fields.customer_autogiro_bankno_old.length === 0 ||
            fields.customer_autogiro_bankno.length === 0)
        {
            return false;
        }

        // Bank account numbers are the same - don't allow
        if (fields.customer_autogiro_bank_clearingno_old === fields.customer_autogiro_bank_clearingno &&
            fields.customer_autogiro_bankno_old === fields.customer_autogiro_bankno)
        {
            return false;
        }
    }

    if (fields.checkbox_change_email.checked)
    {
        if (fields.customer_email_old.length === 0 || fields.customer_email_new.length === 0)
        {
            return false;
        }

        // Emails are same
        if (fields.customer_email_old === fields.customer_email_new)
        {
            return false;
        }
    }
    else if (!fields.is_company && (fields.customer_email.length === 0 || !Validator.validateEmail(fields.customer_email)))
    {
        return false;
    }

    return true;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/CustomerInformation/fair-kundinfo/CustomerInformation.fulfillment.js